import React from "react";
import { getEmployeeByEmail } from "@api";

type Data<T> = [T, Error | null, boolean];

export type EmployeeByEmail = {
  id: string;
  name: string;
  email: string;
};

// Backend resolves by EmployeeEmail OR Upn, so this covers both Google and Entra sessions
// with a single call - pass "" to skip the lookup (e.g. while the input isn't a valid email yet).
export function useEmployeeByEmail(
  email: string
): Data<EmployeeByEmail | null> {
  const [details, setDetails] = React.useState<EmployeeByEmail | null>(null);
  const [error, setError] = React.useState<Error | null>(null);
  const [fetching, setFetching] = React.useState(false);

  React.useEffect(() => {
    if (!email) {
      setDetails(null);
      setError(null);
      setFetching(false);
      return;
    }

    let cancelled = false;
    setFetching(true);

    getEmployeeByEmail(email)
      .then((employee) => {
        if (cancelled) return;
        setDetails({
          id: employee.userNtLogin || "",
          name: employee.name || "",
          email: employee.email,
        });
        setError(null);
      })
      .catch((err) => {
        if (cancelled) return;
        setDetails(null);
        setError(err);
      })
      .finally(() => {
        if (!cancelled) {
          setFetching(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [email]);

  return [details, error, fetching];
}
